import type { TermsAndConditionsSectionProps } from './TermsAndConditionsSection';

type SectionData = Omit<TermsAndConditionsSectionProps, 'localePath'>;

export const sections: SectionData[] = [
  {
    header: 'oura_terms_of_use',
    lastUpdated: 'last_updated_july_23_2025',
    paragraphs: [
      'terms_and_conditions_2025_p1',
      'terms_and_conditions_2025_p2',
      {
        getLink: (locale: string) =>
          `https://ouraring.com${locale}privacy-policy`,
        messageKey: 'terms_and_conditions_2025_p3',
      },
    ],
    showPreviousTermsLink: true,
    useH1Variant: true,
    useH1Element: true,
  },
  {
    header: 'access_and_use',
    paragraphs: [
      'terms_and_conditions_2025_p4',
      'terms_and_conditions_2025_p5',
      'terms_and_conditions_2025_p6',
      'terms_and_conditions_2025_p7',
      'terms_and_conditions_2025_p8',
      'terms_and_conditions_2025_p9',
      'terms_and_conditions_2025_p10',
      'terms_and_conditions_2025_p11',
    ],
  },
  {
    header: 'customer_responsibilities',
    paragraphs: [
      'terms_and_conditions_2025_p12',
      'terms_and_conditions_2025_p13',
      'terms_and_conditions_2025_p14',
      'terms_and_conditions_2025_p15',
      'terms_and_conditions_2025_p16',
    ],
  },
  {
    header: 'payment_and_fees',
    paragraphs: [
      'terms_and_conditions_2025_p17',
      'terms_and_conditions_2025_p18',
      'terms_and_conditions_2025_p19',
      'terms_and_conditions_2025_p20',
      'terms_and_conditions_2025_p21',
    ],
  },
  {
    header: 'subscriptions',
    paragraphs: [
      'terms_and_conditions_2025_p22',
      'terms_and_conditions_2025_p23',
      {
        getLink: (locale: string) => `https://support.ouraring.com/hc${locale}`,
        messageKey: 'terms_and_conditions_2025_p24',
      },
      'terms_and_conditions_2025_p25',
      'terms_and_conditions_2025_p26',
      'terms_and_conditions_2025_p27',
      'terms_and_conditions_2025_p28',
      'terms_and_conditions_2025_p29',
      'terms_and_conditions_2025_p30',
    ],
  },
  {
    header: 'data_and_communications',
    paragraphs: [
      {
        getLink: (locale: string) =>
          `https://ouraring.com${locale}privacy-policy`,
        messageKey: 'terms_and_conditions_2025_p31',
      },
      'terms_and_conditions_2025_p32',
      'terms_and_conditions_2025_p33',
    ],
  },
  {
    header: 'intellectual_property_rights',
    paragraphs: [
      'terms_and_conditions_2025_p34',
      'terms_and_conditions_2025_p35',
      'terms_and_conditions_2025_p36',
      'terms_and_conditions_2025_p37',
    ],
  },
  {
    header: 'warranty_disclaimer',
    paragraphs: [
      'terms_and_conditions_2025_p38',
      'terms_and_conditions_2025_p39',
      'terms_and_conditions_2025_p40',
    ],
  },
  {
    header: 'limitation_of_liability',
    paragraphs: [
      'terms_and_conditions_2025_p41',
      'terms_and_conditions_2025_p42',
    ],
  },
  {
    header: 'precautions',
    paragraphs: [
      'terms_and_conditions_2025_p43',
      'terms_and_conditions_2025_p44',
      'terms_and_conditions_2025_p45',
      'terms_and_conditions_2025_p46',
      'terms_and_conditions_2025_p47',
      'terms_and_conditions_2025_p48',
      'terms_and_conditions_2025_p49',
      'terms_and_conditions_2025_p50',
      'terms_and_conditions_2025_p51',
    ],
  },
  {
    header: 'notice_for_california_users',
    paragraphs: [
      'terms_and_conditions_2025_p52',
      {
        className: 'ml-8',
        messageKey: 'terms_and_conditions_2025_p53',
      },
    ],
  },
  {
    header: 'termination_cancellation',
    paragraphs: [
      'terms_and_conditions_2025_p54',
      'terms_and_conditions_2025_p55',
      {
        getLink: (locale: string) => `https://support.ouraring.com/hc${locale}`,
        messageKey: 'terms_and_conditions_2025_p56',
      },
      'terms_and_conditions_2025_p57',
    ],
  },
  {
    header: 'federal_government_end_use_restrictions',
    paragraphs: ['terms_and_conditions_2025_p58'],
  },
  {
    header: 'export_compliance_and_use_restrictions',
    paragraphs: ['terms_and_conditions_2025_p59'],
  },
  {
    header: 'governing_law_class_action_waiver',
    paragraphs: ['terms_and_conditions_2025_p60'],
  },
  {
    header: 'miscellaneous',
    paragraphs: [
      'terms_and_conditions_2025_p61',
      'terms_and_conditions_2025_p62',
      'terms_and_conditions_2025_p63',
      'terms_and_conditions_2025_p64',
      'terms_and_conditions_2025_p65',
      'terms_and_conditions_2025_p66',
    ],
  },
  {
    header: 'modification_of_the_terms_and_services',
    paragraphs: ['terms_and_conditions_2025_p67'],
  },
  {
    header: 'oura_terms_of_delivery',
    lastUpdated: 'last_updated_march_4_2024',
    paragraphs: [],
    useH1Variant: true,
  },
  {
    header: 'canada_and_the_uk',
    paragraphs: ['terms_and_conditions_2025_p68'],
  },
  {
    header: 'the_european_union_and_usa',
    paragraphs: ['terms_and_conditions_2025_p69'],
  },
  {
    header: 'outside_the_countries_listed_above',
    paragraphs: ['terms_and_conditions_2025_p70'],
  },
];
